import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const Container = styled(Link)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 45px;
  text-decoration: none;
  background: none;
  &:hover {
    background-color: var(--color-greyF8);
  }
`;

export const Item = styled.span`
  width: ${({ width }) => `calc(${width} - 10px)`};
  font-size: ${({ $fontSize }) => ($fontSize === 10 && 'var(--font-size10)') || 'var(--font-size20)'};
  font-weight: ${({ $fontSize }) => ($fontSize === 10 && 600) || 400};
  text-transform: ${({ $fontSize }) => ($fontSize === 10 || $fontSize === 13 ? 'uppercase' : 'none')};
  letter-spacing: ${({ $fontSize }) => ($fontSize === 10 && 1.01) || 0.5}px;
  color: ${({ $color }) => $color || 'var(--color-grey6A)'};
  text-align: left;
`;
